import React, { useState, FormEvent } from 'react';
import IntroContainer from '../IntroContainer/IntroContainer';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import ZoomFlow from '../ZoomVideoProvider/ZoomFlow';
import { trackPageView } from '@tourlane/tracking';

export enum Steps {
  roomNameStep,
  zoomConnectingStep,
}

export default function PreJoinScreens() {
  const [step, setStep] = useState(Steps.roomNameStep);

  React.useEffect(() => {
    if (process.env.REACT_APP_DEPLOYED_TO) {
      trackPageView({
        pageType: step === Steps.roomNameStep ? 'room-name' : 'zoom-connecting',
      });
    }
  }, [step]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStep(Steps.zoomConnectingStep);
  };

  if (step === Steps.zoomConnectingStep) {
    return <ZoomFlow />;
  }

  return (
    <IntroContainer>
      <RoomNameScreen handleSubmit={handleSubmit} />
    </IntroContainer>
  );
}
